import { env } from '@/lib/env';
import { api, getAccessToken } from '@/lib/api';

export type ThemePref = 'light' | 'dark' | 'system';
export type NotifChannel = 'push' | 'email' | 'whatsapp';

export interface UserPreferences {
  theme?: ThemePref;
  locale?: string;
  notifChannels?: NotifChannel[];
  notifMatrix?: Record<string, Record<NotifChannel, boolean>>;
  fiscalTolerancePct?: number;
}

export interface MeDTO {
  id: string;
  email: string;
  name: string;
  crm: string;
  specialty: string | null;
  phoneE164: string;
  emailVerifiedAt: string | null;
  phoneVerifiedAt: string | null;
  inboundAlias: string;
  preferences: UserPreferences;
  consentVersion: string;
  createdAt: string;
}

export interface UpdateMePayload {
  name?: string;
  crm?: string;
  specialty?: string;
  phoneE164?: string;
  preferences?: UserPreferences;
}

export interface BillingMe {
  plan: {
    code: string;
    name: string;
    maxCnpjs: number;
    features: Record<string, boolean | undefined>;
    priceCents: number | null;
    interval: string;
  };
  subscription: {
    status: string;
    currentPeriodStart: string;
    currentPeriodEnd: string;
  };
  features: Record<string, boolean | undefined>;
}

export interface DeleteMeResponse {
  deletedAt: string;
  purgeScheduledAt: string;
}

export const settingsApi = {
  getMe: () => api.get<MeDTO>('/users/me'),
  updateMe: (body: UpdateMePayload) => api.patch<MeDTO>('/users/me', body),
  deleteMe: () => api.delete<DeleteMeResponse>('/users/me'),
  getBilling: () => api.get<BillingMe>('/billing/me'),
  exportUrl: (): string => {
    const base = env.apiBaseUrl.replace(/\/$/, '');
    return `${base}/users/me/export`;
  },
  async downloadExport(): Promise<void> {
    const token = getAccessToken();
    const res = await fetch(settingsApi.exportUrl(), {
      method: 'GET',
      credentials: 'include',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) throw new Error(`Falha ao exportar (${res.status})`);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'organizaai-export.zip';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};
